import * as React from "react"
import { useSelector } from "react-redux"
import { RoleType } from "../../../App/enums"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { RootState } from "../../../App/store"
import "../../../Styles/main.scss"
import FeedCTASlider from "./FeedCTASlider"
import FeedItem from "./FeedItem"
import FeedEntities from "./FeedNewEntities"
import useWindowSize from "../Hooks/useWindowSize"
import SponsorCard from "./SponsorCard"

function FeedContainer(props: { type: RoleType.USER | RoleType.ORGANIZATION; isLoading: boolean }) {
    const posts = useSelector((state: RootState) => state.RoomPostsSlice.roomPostsSlice.posts)
    const translation = useSelector(selectTranslations)
    const screenWidth = useWindowSize()
    const breakpoint = 1023
    const isMobile = screenWidth < breakpoint
    const loadingCards = [0, 1, 2]

    return (
        <>
            {props.isLoading && posts.length === 0 && (
                <>
                    {loadingCards.map((index) => (
                        <div key={`feed-loading-${index}`} className={`feed-item__loading-card feed-item__loading-card--playful feed-item__loading-card--delay-${index}`}>
                            <div className="feed-item__skeleton-header">
                                <div className="feed-item__skeleton-avatar" />
                                <div className="feed-item__skeleton-title-group">
                                    <div className="feed-item__skeleton-line feed-item__skeleton-line--title" />
                                    <div className="feed-item__skeleton-line feed-item__skeleton-line--subtitle" />
                                </div>
                            </div>

                            <div className="feed-item__skeleton-body">
                                <div className="feed-item__skeleton-line" />
                                <div className="feed-item__skeleton-line feed-item__skeleton-line--short" />
                                <div className="feed-item__skeleton-line feed-item__skeleton-line--tiny" />
                            </div>

                            <div className="feed-item__skeleton-media" />

                            <div className="feed-item__skeleton-footer">
                                <div className="feed-item__skeleton-pill" />
                                <div className="feed-item__skeleton-pill feed-item__skeleton-pill--small" />
                                <div className="feed-item__skeleton-pill" />
                            </div>
                        </div>
                    ))}
                </>
            )}

            {posts?.map((post, index) => {
                if (index === 0) {
return (
            <React.Fragment key={`feed-first-${post.id}`}> 
                <FeedItem isLoading={false} type={props.type} post={post} />
                <FeedCTASlider />
            </React.Fragment>
        )
                }
                else if (isMobile && index === 3) {
                    return (
                        [
                            <div className="organization-dashboard-feed__sponsor-title " key="mobile-offers-title">{translation.sponsoredText}</div>
                            , <div className="dashboard-feed__sponsor-card" key="mobile-offers-card">
                                <SponsorCard />
                            </div>
                            , <FeedItem key={post.id} isLoading={false} type={props.type} post={post} />
                        ]
                    )
                }
                else if(index === (isMobile ? 5 : 3)){
                    return (
                        [
                            <FeedEntities key={`dyk-${post.id}`} />
                            , <FeedItem key={post.id} isLoading={false} type={props.type} post={post} />
                        ]
                    )
                }
                return <FeedItem key={post.id} isLoading={false} type={props.type} post={post} />
            })}

            {isMobile && posts.length > 0 && posts.length < 4 && (
                <>
                    <div className="organization-dashboard-feed__sponsor-title ">{translation.sponsoredText}</div>
                    <div className="dashboard-feed__sponsor-card">
                        <SponsorCard />
                    </div>
                </>
            )}
        </>
    )
}

export default FeedContainer
